// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import igigiacer from "src/assets/diamond-igi-gia-cer.png";
import giacer from "src/assets/GIAcer.png";
import close from "src/assets/close.svg";
import './DiamondImageGallery.style';
import "sticky-sidebar/dist/sticky-sidebar";
import { connect } from 'react-redux';
import Slider from "react-slick";
import "react-slick/dist/react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Link from '@scandipwa/scandipwa/src/component/Link';

/** @namespace Component/Footer/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
});

export class DiamondImageGallery extends PureComponent {
    static propTypes = {
        product: this.propTypes,
        device: this.propTypes
    };

    state = {
        diamondactiveimage: "diamondproductvideo",
        openCertificate: false,
        onLoadError: false
    }

    typesettings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoPlay: false,
    };

    componentDidMount() {
        const { product } = this.props;

        if (product?.video_url) {
            this.setDiamondActiveImage("diamondproductvideo");
        } else {
            this.setDiamondActiveImage("diamondproductimage");
        }
    }

    renderDiamondImage(diamond_shape) {
        switch (diamond_shape) {
            case "Round":
                return <img src={"/media/diamondshapes/diamondround/diamond-shape-thumbnail.png"} />;
            case "Oval":
                return <img src={"/media/diamondshapes/diamondoval/diamond-shape-thumbnail.png"} />;
            case "Princess":
                return <img src={"/media/diamondshapes/diamondprincess/diamond-shape-thumbnail.png"} />;
            case "Pear":
                return <img src={"/media/diamondshapes/diamondpear/diamond-shape-thumbnail.png"} />;
            case "Emerald":
                return <img src={"/media/diamondshapes/diamondemerald/diamond-shape-thumbnail.png"} />;
            case "Cushion":
                return <img src={"/media/diamondshapes/diamondcushion/diamond-shape-thumbnail.png"} />;
            case "Heart":
                return <img src={"/media/diamondshapes/diamondheart/diamond-shape-thumbnail.png"} />;
            case "Radiant":
                return <img src={"/media/diamondshapes/diamondradiant/diamond-shape-thumbnail.png"} />;
            case "Marquise":
                return <img src={"/media/diamondshapes/diamondmarquise/diamond-shape-thumbnail.png"} />;
            case "Asscher":
                return <img src={"/media/diamondshapes/diamondasscher/diamond-shape-thumbnail.png"} />;
            default:
                return (
                    <></>
                );
        }
    }

    renderDiamondDataImage(diamond_shape) {
        switch (diamond_shape) {
            case "Round":
                return <img src={"/media/diamondshapes/diamondround/diamond-shape-thumbnail-data.png"} />;
            case "Oval":
                return <img src={"/media/diamondshapes/diamondoval/diamond-shape-thumbnail-data.png"} />;
            case "Princess":
                return <img src={"/media/diamondshapes/diamondprincess/diamond-shape-thumbnail-data.png"} />;
            case "Pear":
                return <img src={"/media/diamondshapes/diamondpear/diamond-shape-thumbnail-data.png"} />;
            case "Emerald":
                return <img src={"/media/diamondshapes/diamondemerald/diamond-shape-thumbnail-data.png"} />;
            case "Cushion":
                return <img src={"/media/diamondshapes/diamondcushion/diamond-shape-thumbnail-data.png"} />;
            case "Heart":
                return <img src={"/media/diamondshapes/diamondheart/diamond-shape-thumbnail-data.png"} />;
            case "Radiant":
                return <img src={"/media/diamondshapes/diamondradiant/diamond-shape-thumbnail-data.png"} />;
            case "Marquise":
                return <img src={"/media/diamondshapes/diamondmarquise/diamond-shape-thumbnail-data.png"} />;
            case "Asscher":
                return <img src={"/media/diamondshapes/diamondasscher/diamond-shape-thumbnail-data.png"} />;
            default:
                return (
                    <></>
                );
        }
    }

    renderDiamondShapeImage(diamond_shape) {
        switch (diamond_shape) {
            case "Round":
                return <img src={"/media/diamondshapes/diamondround/diamond-shape-round-thumbnail.png"} />;
            case "Oval":
                return <img src={"/media/diamondshapes/diamondoval/diamond-shape-oval-thumbnail.png"} />;
            case "Princess":
                return <img src={"/media/diamondshapes/diamondprincess/diamond-shape-princess-thumbnail.png"} />;
            case "Pear":
                return <img src={"/media/diamondshapes/diamondpear/diamond-shape-pear-thumbnail.png"} />;
            case "Emerald":
                return <img src={"/media/diamondshapes/diamondemerald/diamond-shape-emerald-thumbnail.png"} />;
            case "Cushion":
                return <img src={"/media/diamondshapes/diamondcushion/diamond-shape-cushion-thumbnail.png"} />;
            case "Heart":
                return <img src={"/media/diamondshapes/diamondheart/diamond-shape-heart-thumbnail.png"} />;
            case "Radiant":
                return <img src={"/media/diamondshapes/diamondradiant/diamond-shape-radiant-thumbnail.png"} />;
            case "Marquise":
                return <img src={"/media/diamondshapes/diamondmarquise/diamond-shape-marquise-thumbnail.png"} />;
            case "Asscher":
                return <img src={"/media/diamondshapes/diamondasscher/diamond-shape-asscher-thumbnail.png"} />;
            default:
                return (
                    <></>
                );
        }
    }

    renderDiamondShapeDataImage(diamond_shape) {
        switch (diamond_shape) {
            case "Round":
                return <img src={"/media/diamondshapes/diamondround/diamond-shape-round-thumbnail-data.png"} />;
            case "Oval":
                return <img src={"/media/diamondshapes/diamondoval/diamond-shape-oval-thumbnail-data.png"} />;
            case "Princess":
                return <img src={"/media/diamondshapes/diamondprincess/diamond-shape-princess-thumbnail-data.png"} />;
            case "Pear":
                return <img src={"/media/diamondshapes/diamondpear/diamond-shape-pear-thumbnail-data.png"} />;
            case "Emerald":
                return <img src={"/media/diamondshapes/diamondemerald/diamond-shape-emerald-thumbnail-data.png"} />;
            case "Cushion":
                return <img src={"/media/diamondshapes/diamondcushion/diamond-shape-cushion-thumbnail-data.png"} />;
            case "Heart":
                return <img src={"/media/diamondshapes/diamondheart/diamond-shape-heart-thumbnail-data.png"} />;
            case "Radiant":
                return <img src={"/media/diamondshapes/diamondradiant/diamond-shape-radiant-thumbnail-data.png"} />;
            case "Marquise":
                return <img src={"/media/diamondshapes/diamondmarquise/diamond-shape-marquise-thumbnail-data.png"} />;
            case "Asscher":
                return <img src={"/media/diamondshapes/diamondasscher/diamond-shape-asscher-thumbnail-data.png"} />;
            default:
                return (
                    <></>
                );
        }
    }

    renderDiamondProductImage(diamond_shape, image_url) {
        const { onLoadError } = this.state;

        switch (diamond_shape) {
            case "Round":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondround/round-sample.jpg";
            case "Oval":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondoval/oval-sample.jpg";
            case "Princess":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondprincess/princess-sample.jpg";
            case "Pear":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondpear/pear-sample.jpg";
            case "Emerald":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondemerald/emerald-sample.jpg";
            case "Cushion":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondcushion/cushion-sample.jpg";
            case "Heart":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondheart/heart-sample.jpg";
            case "Radiant":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondradiant/radiant-sample.jpg";
            case "Marquise":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondmarquise/marquise-sample.jpg";
            case "Asscher":
                return image_url && !onLoadError ? image_url : "/media/diamondshapes/diamondasscher/asscher-sample.jpeg";
            default:
                return (
                    <></>
                );
        }
    }

    setDiamondActiveImage(value) {
        this.setState({
            diamondactiveimage: value
        });
    }

    renderCertificate = () => {
        const { product, device: { isMobile } } = this.props;

        return (
            this.state.openCertificate && <div className="certificateion-model">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <button className="close" onClick={() => this.setState({ openCertificate: false })}>
                            <img src={close} />
                        </button>
                        {
                            product?.cert_url ? <div className="modal-body">
                                {
                                    product?.cert_url?.includes(".pdf")
                                        ? <iframe
                                            width="1000" height={isMobile ? "300" : "600"}
                                            src={product?.cert_url}
                                            className="real-view-video"
                                        ></iframe>
                                        : <img
                                            className="img-responsive origin-cart-popup"
                                            src={product?.cert_url}
                                            alt="Diamond Certificate"
                                        />
                                }
                            </div> : <div className='noncertification-modal-body'>
                                <div className='certification-title'>
                                    The Diamond Comes With a {product?.diamond_certificate} Certificate
                                </div>
                                <div className='certification-subtitle'>
                                    To review certificate copy, please make a call to our toll free number
                                </div>
                                <a href={"phoneto:18002822242"} className='phone-linki'>
                                    1-800-282-2242
                                </a>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { product, device: { isMobile } } = this.props;

        const diamondImageUrl = this.renderDiamondProductImage(product?.diamond_shape, product?.image_url);

        if (isMobile) {
            return (
                <div className="DiamondImageGallery">
                    <div className="diamond-image-gallery">
                        <div className="diamond-image-section-content">
                            <Slider {...this.typesettings}>
                                {
                                    product?.video_url && <div className="thumbnail-images thumbnail-video">
                                        <div className='images'>
                                            {
                                                (product?.video_url.includes(".mp4") || product?.video_url.includes(".MP4")) ? <video height="100%" width="100%" playsInline loop muted autoPlay src={product?.video_url}>
                                                    <source src={product?.video_url} type="video/mp4" />
                                                </video> : <iframe src={product?.video_url} className="real-view-video"></iframe>
                                            }
                                        </div>
                                    </div>
                                }

                                <div className="thumbnail-images">
                                    <div className='images'>
                                        <img onError={() => this.setState({ onLoadError: true })} src={diamondImageUrl} alt={product?.diamond_sku} loading="eager" />
                                    </div>
                                </div>

                                <div className="thumbnail-images main-images-container">
                                    <div className='images'>
                                        {this.renderDiamondDataImage(product?.diamond_shape)}
                                        <span className="diamond-left">
                                            {product?.girdle_min || product?.girdle_max ? `Girdle: ` : ""}
                                            {product?.girdle_min ? `${product?.girdle_min}` : ""}
                                            {product?.girdle_min && product?.girdle_max ? ` To ` : ""}
                                            {product?.girdle_max ? `${product?.girdle_max}` : ""}
                                        </span>
                                        <span className="diamond-right">
                                            {product?.diamond_depth ? `Depth: ${product?.diamond_depth}%` : ""}
                                        </span>
                                        <span className="diamond-top">
                                            {product?.diamond_table_percent ? `Table: ${product?.diamond_table_percent}%` : ""}
                                        </span>
                                        <span className="diamond-bottom">
                                            {product?.diamond_culet ? `Culet: ${product?.diamond_culet}` : ""}
                                        </span>
                                    </div>
                                </div>

                                <div className="thumbnail-images main-images-container">
                                    <div className='images'>
                                        {this.renderDiamondShapeDataImage(product?.diamond_shape)}
                                        {
                                            product?.diamond_measurement ? <>
                                                <span className="diamond-height">Length: {product?.diamond_measurement?.split("x")[0]}</span>
                                                <span className="diamond-width">Width: {product?.diamond_measurement?.split("x")[1]}</span>
                                            </> : ""
                                        }
                                    </div>
                                </div>

                                {
                                    product?.cert_url ? <div
                                        className="thumbnail-images thumbnail-video"
                                    >
                                        <Link isOpenInNewTab={true} to={product?.cert_url}>
                                            <div
                                                className='images igigiacer'
                                            // to={product?.cert_url}
                                            // isOpenInNewTab={true}
                                            // onClick={() => this.setState({ openCertificate: true })}
                                            >
                                                <img src={product?.diamond_certificate === "GIA" ? giacer : igigiacer} />
                                                <span>tap to view details</span>
                                            </div>
                                        </Link>
                                    </div> : <div
                                        className="thumbnail-images thumbnail-video"
                                        onClick={() => this.setState({ openCertificate: true })}
                                    >
                                        <div className='images igigiacer'>
                                            <img src={product?.diamond_certificate === "GIA" ? giacer : igigiacer} />
                                            <span>tap to view details</span>
                                        </div>
                                    </div>
                                }
                            </Slider>
                        </div>

                        {this.renderCertificate}
                    </div>
                </div>
            )
        }

        return (
            <div className="DiamondImageGallery">
                <div className="diamond-image-gallery">
                    <div className="DiamondImageGallery-ImageGallery diamond-image-section-content">
                        <div className="thumbnail-images main-images-container">
                            {this.renderDiamondDataImage(product?.diamond_shape)}
                            {(product?.girdle_min || product?.girdle_max) && <span className="diamond-left">
                                {product?.girdle_min || product?.girdle_max ? `Girdle: ` : ""}
                                {product?.girdle_min ? `${product?.girdle_min}` : ""}
                                {product?.girdle_min && product?.girdle_max ? ` To ` : ""}
                                {product?.girdle_max ? `${product?.girdle_max}` : ""}
                            </span>}
                            <span className="diamond-right">
                                {product?.diamond_depth ? `Depth: ${product?.diamond_depth}%` : ""}
                            </span>
                            <span className="diamond-top">
                                {product?.diamond_table_percent ? `Table: ${product?.diamond_table_percent}%` : ""}
                            </span>
                            <span className="diamond-bottom">
                                {product?.diamond_culet ? `Culet: ${product?.diamond_culet}` : ""}
                            </span>
                        </div>

                        <div className="thumbnail-images main-images-container">
                            {this.renderDiamondShapeDataImage(product?.diamond_shape)}
                            {
                                product?.diamond_measurement ? <>
                                    <span className="diamond-height">Length: {product?.diamond_measurement?.split("x")[0]}</span>
                                    <span className="diamond-width">Width: {product?.diamond_measurement?.split("x")[1]}</span>
                                </> : ""
                            }
                        </div>

                        <div className="thumbnail-images">
                            <img onError={() => this.setState({ onLoadError: true })} src={diamondImageUrl} alt={product?.diamond_sku} loading="eager" />
                        </div>

                        {product?.video_url && <div className="thumbnail-images thumbnail-video">
                            {
                                (product?.video_url.includes(".mp4") || product?.video_url.includes(".MP4")) ? <video height="100%" width="100%" loop muted autoPlay>
                                    <source src={product?.video_url} type="video/mp4" />
                                </video> : <iframe src={product?.video_url} className="real-view-video"></iframe>
                            }
                        </div>}

                        {product?.diamond_certificate && <div
                            className="thumbnail-images"
                        // onClick={() => this.setState({ openCertificate: true })}
                        >
                            <Link isOpenInNewTab={true} to={product?.cert_url}>
                                <div className='images igigiacer'>
                                    <img src={product?.diamond_certificate === "GIA" ? giacer : igigiacer} />
                                    <span>tap to view details</span>
                                </div>
                            </Link>
                        </div>}
                    </div>

                    {/* {this.renderCertificate} */}
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(DiamondImageGallery);
